import clients from "@/business/clients/infrastructure/config/clients.json";
import { Client, ClientActions } from "../../domain/clients";

export const getAllClientsService = {
  async execute(): Promise<Client[]> {
    const allClients = clients;

    return new Promise((resolve) => {
      resolve(
        allClients.map((client) => {
          return ClientActions().clientInfo(
            client.clientId,
            client.identificationType,
            client.identificationNumber,
            client.company,
            client.contactName,
            client.contactEmail,
            client.contactPhone,
            client.billingEmail,
            false
          );
        })
      );
    });
  },
};
